import { log } from 'utils/error-logging';
import type { ApiCallResponse } from 'api/types';
import basketBuilderExperience from 'api/definitions/basket-builder-experience';
import type { BasketBuilderExperienceSuggestionsResponse } from 'api/definitions/basket-builder-experience/types';
import { getPathname, getPreviousPaths } from 'redux/modules/routing/selectors';
import { TRANSFORM_BASKET_BUILDER_SUGGESTIONS_INTO_LEGACY_FORMAT } from 'redux/transforms';
import { SUGGESTIONS_SCHEMA } from 'redux/schemas';
import { getSlotType } from 'redux/modules/customer-slot/selectors';
import { SlotTypes } from 'constants/fulfilmentTypes';
import { GET_QUICK_SHOP_SUGGESTIONS } from './types';
import { QUICK_SHOP_PAGE_SIZE } from '../constants';

export const fetchBasketSuggestionsProducts =
  (): WtrThunkAction<Promise<void | BasketBuilderExperienceSuggestionsResponse>> =>
  (dispatch, getState) => {
    const state = getState();
    const currentPath = getPathname(state);
    const previousPaths = getPreviousPaths(state);
    const isInPageUrlUpdate = currentPath === previousPaths?.at(-1);

    if (isInPageUrlUpdate) {
      return Promise.resolve();
    }

    const slotType = getSlotType(state);

    return dispatch({
      types: GET_QUICK_SHOP_SUGGESTIONS.triplet,
      apiCall: basketBuilderExperience.getSuggestions({
        size: QUICK_SHOP_PAGE_SIZE,
        slotType: slotType !== SlotTypes.UNDEFINED ? slotType : undefined,
        excludeSuggestionsInTrolley: true,
      }),
      schema: SUGGESTIONS_SCHEMA,
      transform: TRANSFORM_BASKET_BUILDER_SUGGESTIONS_INTO_LEGACY_FORMAT,
    }).catch(error => {
      log(error, { logger: 'basket-builder-experience', section: 'quick-shop' });
    }) as Promise<void | ApiCallResponse<BasketBuilderExperienceSuggestionsResponse>>;
  };
